import { createFileRoute } from '@tanstack/react-router';
import UserGroupPermissions from '../../../administration/src/components/UserGroups/UserGroupDetails/UserGroupPermissions';

export const Route = createFileRoute('/_secured/administration/user-groups/$groupId/permissions/$page/$limit')({
  component: UserGroupPermissions,
});
